(() => {
  const videos = document.querySelectorAll('.catalogue-variant-video[data-delayed-autoplay="true"]');

  const revealVideo = (video) => {
    const stage = video.closest("[data-catalogue-video-stage]");
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute("muted", "");
    video.setAttribute("loop", "");
    video.setAttribute("playsinline", "");

    const playPromise = video.play();
    if (playPromise && playPromise.catch) playPromise.catch(() => {});

    video.addEventListener(
      "playing",
      () => {
        stage?.classList.add("is-video-playing");
      },
      { once: true }
    );
  };

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const video = entry.target.querySelector(".catalogue-variant-video") || entry.target;
          revealVideo(video);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "160px 0px", threshold: 0.01 }
    );

    videos.forEach((video) => {
      observer.observe(video.closest("[data-catalogue-video-stage]") || video);
    });
  } else {
    videos.forEach(revealVideo);
  }
})();
